var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./MyADGPayPopup.jinja');
require('./MyADGPayPopup.less');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({

    }, BasePopup.prototype.baseEvents),


    initialize: function (options) {
        this.options = options || {};

        this.createIframe();

        BasePopup.prototype.initialize.call(this, options);
    },


    createIframe: function () {
        this._xhr && this._xhr.abort();

        this._xhr = $.ajax(Urls['member:api:pay-dues']('json'), {
            method: 'GET',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            'success': function (data) {
                var $iframe = $('<iframe width="100%" height="100%" border="0"></iframe>');
                $iframe.attr('src', data);
                this.$('.MyADGPayPopup-iframe').append($iframe);
            }.bind(this),
            'error': function (data) {
                this.$('.MyADGPayPopup-iframe').addClass('MyADGPayPopup-iframe--error');
                console.log(data);
            }.bind(this)
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MyADGPayPopup/MyADGPayPopup.js
// module id = 282
// module chunks = 0